import axios from 'axios'
import { makeAxios } from '@vue-composable/axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

export const {
  data,
  exec,
  status,
  statusText,
  isCancelled,
  cancelledMessage,
  promise,
  result,
  loading,
  error
} = makeAxios(client)
